export default __webpack_public_path__ + "static/media/may2023-4.8d1e56e9.jpg";